import { DefaultError, useQuery } from '@tanstack/react-query';
import { ILightListItem } from 'services/types';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';

export const useGetChannelLightList = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ILightListItem[], DefaultError>({
    queryKey: ['channel-light-list'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Channel/LightList`,
      });

      return responseHandler(response, {
        groupName: `useGetChannelLightList`,
      });
    },
  });
};
